import { adminClusteredPinsImages } from '../AdminClusteredPins';
import { trailCollectionImages } from '../TrailCollection';
import DynamicStyleOverlays from './DynamicStyleOverlays';

export default DynamicStyleOverlays;
export type { ListItemsProps, MergeTargetTrail } from '../HoveredResultCardAndPolyline';

export const dynamicStyleImages = {
  ...trailCollectionImages,
  ...adminClusteredPinsImages
};
